let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3tl4f")).then(() => parcelRequire('8wb1L'));